


























































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
@Component({
  components: {},
})
export default class DateSelection extends Vue {
  @Prop(Number) unitId: any;
  private dataText: any = '123123';
  private drawer = false;

  private form: any = {
    title: '日期',
    placeholder: '请选择',
    required: false,
  };

  private options: any = [
    {
      value: '年-月-日',
      label: '年-月-日',
    },
    {
      value: '年-月-日 时:分',
      label: '年-月-日 时:分',
    },
  ];

  // 选项列表
  private optionsList: any = [];

  closeTap() {
    console.log(this.unitId);
    this.$emit('i_close', { id: this.unitId });
  }
}
